import { ApiTagType } from '@/core/generated/api';

export type SupportedTagType = Exclude<ApiTagType, typeof ApiTagType.Undefined>;

export interface TagTypeOption {
    id: SupportedTagType;
    name: string;
}

/** Содержит типы фиксированных тегов */
export const TAG_TYPE_OPTIONS: TagTypeOption[] = [
    {
        id: ApiTagType.LinkToAmmunitionOnYandexMarket,
        name: 'Ссылка на амуницию в Яндекс Маркете',
    },
    {
        id: ApiTagType.ExecutorRecruiterTelegramLink,
        name: 'Ссылка Telegram рекрутера',
    },
];

/** Проверяет тип фиксированного тега */
export const isSupportedTagType = (value: string | undefined): value is SupportedTagType =>
    TAG_TYPE_OPTIONS.some((option) => option.id === value);

/** Возвращает название типа фиксированного тега */
export const getTagTypeName = (tagType: ApiTagType | undefined): string =>
    TAG_TYPE_OPTIONS.find((option) => option.id === tagType)?.name ?? '—';

/** Проверяет, что тег содержит ссылку */
export const isLinkTagType = (tagType: ApiTagType | undefined): boolean =>
    tagType === ApiTagType.LinkToAmmunitionOnYandexMarket
    || tagType === ApiTagType.ExecutorRecruiterTelegramLink;
